var exports = {
  "kL": "x804f0401--0f9cc9--container",
  "Sl": "x804f0401--0f9cc9--image",
  "h_": "x804f0401--0f9cc9--description",
  "XI": "x804f0401--0f9cc9--action",
};

module.exports = exports;
